import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { InfoIcon } from 'hosman-material';
import { S_Check, D_House, D_UserPen, D_UserGroup } from 'hosman-material';

import { updateMandate } from '../../../../../../../../reducers/SellerApp/mandatesSlice';

const options = [
  { id: 1, value: 'solo_owner', name: "Je suis l'unique propriétaire de ce bien", icon: D_House },
  { id: 2, value: 'n_owners_solo_signer', name: 'Il y a plusieurs propriétaires et je souhaite signer seul le mandat', icon: D_UserPen, tooltipLabel: 'Dans quel cas puis-je signer seul ?', tooltip: "Si vous êtes plusieurs propriétaires, il vous suffit d'obtenir le pouvoir des autres propriétaires pour signer seul le mandat." },
  { id: 3, value: 'n_owners_n_signers', name: 'Il y a plusieurs propriétaires et je souhaite que tous signent le mandat', icon: D_UserGroup }
]

const SituationSelect = ({ setError }) => {
  const { sale } = useSelector((state) => state.sellerSales);
  const { mandate: { sign_person } } = useSelector((state) => state.sellerMandates);
  const dispatch = useDispatch();

  const handleChange = (option) => {
    setError()
    dispatch(updateMandate({
      mandateId: sale.original_mandate_id, 
      params: { sign_person: option.value }
    }))
  }

  return (
    <div className='flex flex-col gap-8' data-testid='SituationSelect'>
      {options.map(option => {
        return (
          <div key={option.id} className='flex flex-col gap-3'>
            <div onClick={() => handleChange(option)} className={`flex items-center gap-3 p-5 ${option.value === sign_person ? 'border-2 border-ih-blue' : 'border border-ih-blue-30'} rounded-3xl cursor-pointer`}>
              <div className='w-max'>
                <div className={`w-7 h-7 flex justify-center items-center border border-ih-blue-30 rounded-full ${option.value === sign_person ? 'bg-ih-blue' : ''}`}>
                  <FontAwesomeIcon icon={S_Check} className='text-white' />
                </div>
              </div>

              <FontAwesomeIcon icon={option.icon} size='xl' />

              <p className='font-bold'>{option.name}</p>
            </div>

            {option.tooltip &&
              <InfoIcon 
                tooltip={<p className='w-60'>{option.tooltip}</p>}
                label={option.tooltipLabel}
              />
            }
          </div>
        )
      })}
    </div>
  );
}

export default SituationSelect;
